<div class="details-table">
  <fz-shared-table-component
    [displayedColumns]="displayedColumns"
    [dataSource]="prizeDetails"
    [configuration]="configuration"
  ></fz-shared-table-component>
</div>
